import { useState } from "react";
import { FormControl as Input } from "react-bootstrap";
import { useDispatch } from "react-redux";
import RoleBased from "components/Role/RoleBased";

import Table from "./Table";
import DefaultButton from "components/DefaultButton";

const GroupsList = () => {

    const [search, SetSearch] = useState("");

    const dispatch = useDispatch();

    return (
        <div className="card">
            <div className="card-body">
                <h3 className="title">Turmas</h3>
                <p className="text-muted">Aqui são listados todas as turmas do sistema</p>
                <hr/>
                <div className="flex jcsb flex-wrap margin-bottom">
                    <Input
                        placeholder="Pesquisar pelo Nome"
                        value={search}
                        onChange={e => SetSearch(e.target.value)}
                        style={{ width: "50%" }}
                    />
                    <RoleBased>
                        <DefaultButton
                            bg="confirm"
                            text="Adicionar novo turma"
                            to="/groups/add"
                        />
                    </RoleBased>
                </div>
                <Table
                    search={search}
                />
            </div>
        </div>
    );
}

export default GroupsList;